import { Chip } from '@mui/material';

export function DataSetCategories({ tests, dataSetType }) {
  const faceBucket = [
    { name: 'LEFT', count: 0 },
    { name: 'RIGHT', count: 0 },
    { name: 'NONE', count: 0 },
    { name: 'MILD', count: 0 },
    { name: 'MODERATE', count: 0 },
    { name: 'SEVERE', count: 0 },
  ];
  const armsBucket = [
    { name: 'LEFT', count: 0 },
    { name: 'RIGHT', count: 0 },
    { name: 0, count: 0 },
    { name: 1, count: 0 },
    { name: 2, count: 0 },
    { name: 3, count: 0 },
    { name: 4, count: 0 },
  ];
  const speechBuckets = [
    { name: 'NONE', count: 0 },
    { name: 'MILD', count: 0 },
    { name: 'MODERATE', count: 0 },
    { name: 'SEVERE', count: 0 },
  ];

  tests.forEach((test) => {
    const neurologicalExamination = test.neurologicalExamination;
    speechBuckets.forEach((b) => {
      if (b.name === neurologicalExamination?.dysarthria) {
        b.count += 1;
      }
    });
    faceBucket.forEach((b) => {
      const facialDroop = test.neurologicalExamination?.facialDroop;
      if (b.name === facialDroop?.side || b.name === facialDroop?.severity) {
        b.count += 1;
      }
    });
    armsBucket.forEach((b) => {
      const armWeakness = test.neurologicalExamination?.armWeakness;
      if (b.name === armWeakness?.side || b.name === armWeakness?.level) {
        b.count += 1;
      }
    });
  });

  const categories = { SPEECH: speechBuckets, FACE: faceBucket, ARMS: armsBucket };

  return (
    <>
      {categories[dataSetType].map((t) => (
        <Chip key={t.name} sx={{ minWidth: 90, marginLeft: 1 }} label={`${t.name} - ${t.count}`} />
      ))}
    </>
  );
}
